<template>
  <div class="page-wrapper">
    <div class="fullscreen-image" style="background-image:url('https://storage.googleapis.com/kokoro-294123.appspot.com/login-bg.jpg')">
      <div class="logo">
        <img src="https://storage.googleapis.com/kokoro-294123.appspot.com/logo-white.svg"/>
      </div>
      <div class="center-container">
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <h4>Shop Manager</h4>
            </v-col>
          </v-row>
          <v-alert class="my-1" type="error" dense text v-if="errMsg">
            {{errMsg}}
          </v-alert>

          <v-row class="form-group my-0">
            <v-col cols="12">
<!--              <input type="email" class="form-control text-center" v-model="email" placeholder="이메일" @keyup.enter="signIn"/>-->
              <v-text-field class="form-control centered-input" placeholder="Username" v-model="email" solo dense @keyup.enter="signIn"/>
            </v-col>
          </v-row>
          <v-row class="form-group my-0">
            <v-col class="pb-0">
<!--              <input type="password" class="form-control text-center" v-model="password" placeholder="비밀번호" @keyup.enter="signIn"/>-->
              <v-text-field type="password" class="form-control centered-input" placeholder="Password" v-model="password" solo dense @keyup.enter="signIn"/>
            </v-col>
          </v-row>
          <v-row class="form-group my-0">
            <v-col class="py-0">
              <v-checkbox dense v-model="keep">
                <template v-slot:label>
                  <div class="mt-1">Keep me signed in</div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-btn class="primary" block @click="signIn">SIGN IN</v-btn>
              <v-btn to="/password" text block class="mt-2">FORGET PASSWORD?</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="info-container">
        <strong>Kokoro Trading LTD</strong>
<!--        <br>4 Lyon Road, Hersham, Walton-on-Thames, KT12 3PU<br>-->
<!--        <br>Application provided by<br><strong>Borium Studio Limited</strong>-->
<!--        <br>-->

        <br>Copyright @ Kokoro Trading LTD
      </div>
    </div>
    <v-dialog>
      <v-card>
        <v-card-title></v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import EventBus from '../api/event-bus.js';
    import {userSignIn, getMenuItems} from '../api/user'

    export default {
        name: "Login",
        data() {
            return {
                mode:0,
                email:'',
                password:'',
                newEmail:'',
                newName:'',
                newPwd:'',
                newPwd2:'',
                newLevel: 0,
                errMsg: null,

              loading: false,
              keep: false,
            }
        },
        created() {
          console.log("KEEP " + localStorage.getItem("keep"));
          if(localStorage.getItem("keep") != null) {
            this.$data.keep = localStorage.getItem("keep");
          }
        },
        mounted() {
          this.autoLogin();
        },
        methods: {
            autoLogin: function() {
              // console.log(localStorage.getItem("email"))
              console.log("KEEP " + localStorage.getItem("keep"));
              if(localStorage.getItem("email") != null && localStorage.getItem("password") != null) {
                this.$data.email = localStorage.getItem("email");
                this.$data.password = localStorage.getItem("password");
                this.signIn();
              } else if(auth.isAuthorised()){
                // this.$router.push('/home');
              }
            },
            signIn: function() {
                let self = this;
                // EventBus.$emit("showLoading", true);
                userSignIn(this.$data.email, this.$data.password)
                    .then(function(data){
                      // EventBus.$emit("showLoading", false);
                      console.log("Successful signin " + data.success);
                      console.log(data)
                      if(data.success) {
                        console.log("Successful signin");
                        // localStorage.setItem("JSTOKEN", data.item.token);
                        // localStorage.setItem("email", data.item.email);
                        // localStorage.setItem("id", data.item.id);

                        // localStorage.setItem("email", self.$data.email);
                        // localStorage.setItem("password", self.$data.password);

                        // auth.saveAuthInfo(self.email, self.password, data.item.token)

                        auth.logIn(data.item)

                        localStorage.setItem("keep", self.keep);
                        if(self.keep) auth.saveAuthInfo(self.email, self.password)

                        if(data.item.type === 'ROLE_MERCHANT') {
                          EventBus.$emit("setUserType", 'merchant');
                          self.$router.push('/home');
                        } else if(data.item.type === 'ROLE_DRIVER') {
                          EventBus.$emit("setUserType", 'driver');
                          self.$router.push('/driver');
                        } else if(data.item.type === 'ROLE_ADMIN' || data.item.type === 'ROLE_MANAGER') {
                          EventBus.$emit("setUserType", 'admin');
                          self.$router.push('/orders');
                        } else if(data.item.type === 'ROLE_STOCK_MANAGER') {
                          EventBus.$emit("setUserType", 'stock_manager');
                          if(data.item.wmsPick === true || data.item.wmsPickCheck === true || data.item.wmsPickConfirm === true) {
                            self.$router.push('/orderstocks');
                          } else if(data.item.wmsManage === true) {
                            self.$router.push('/wms');
                          }
                        }

                        self.errMsg = null
                      } else {
                        auth.logOut()

                        self.errMsg = data.message
                      }
                    })
                    .catch(function(err){
                        // EventBus.$emit("showLoading", false);
                        console.log("Error " + err);
                        console.log(err.response);
                        EventBus.$emit("logon", false);
                    })
            }
        }
    }
</script>

<style lang="css" scoped>
  .centered-input >>> input {
    text-align: center
  }

  .center-container {
    min-width: 300px;
    padding:10px;
    background: white;
    border-radius: 10px;
    top:300px;
  }
  @media only screen and (min-device-height: 1000px) {
    .center-container {
      top:400px;
    }
  }
  .logo {
    max-width: 400px;
    position: absolute;
    top:50px;
    left:50%;
    transform: translateX(-50%);

  }
  .logo > img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue